import React from "react";
import {useLocation} from "react-router-dom";

export function CheckoutProgress() {
    const location = useLocation()
    const steps = ["Account", "Address", "Delivery", "Payment"];

    const stepMap = {
        "/checkout/address": 1,
        "/checkout/delivery": 2,
        "/checkout/payment": 3,
    }

    const currentStep = stepMap[location.pathname] || 0

    return (
        <>
            <div className="container my-3">
                <div className="d-flex justify-content-between mb-2">
                    {steps.map((step, index) => (
                        <div key={index}
                             className={`text-center flex-fill border-5 border-bottom ${index <= currentStep ? 'fw-bold text-info border-info' : 'text-muted border-light-subtle'}`}>
                            {step}
                        </div>
                    ))}
                </div>
            </div>

            {/*<div className="d-flex justify-content-center justify-content-md-start px-2">*/}
            {/*    <div className="d-flex align-items-center justify-content-between w-75 my-4 ">*/}

            {/*        {steps.map((step, index) => (*/}

            {/*            <div key={index}*/}
            {/*                // className="d-flex align-items-center flex-grow-1 position-relative"*/}
            {/*                 className={`d-flex align-items-center position-relative ${index === steps.length - 1 ? "" : "flex-grow-1"}`}*/}
            {/*            >*/}

            {/*                {index < steps.length - 1 && (*/}
            {/*                    <div*/}
            {/*                        className={`border-top border-2 position-absolute top-50 start-0 ${*/}
            {/*                            index <= currentStep ? "border-primary" : "border-light-subtle"*/}
            {/*                        }`}*/}
            {/*                        style={{width: "100%", left: "-50%", zIndex: -1}}*/}
            {/*                    ></div>*/}
            {/*                )}*/}

            {/*                <div*/}
            {/*                    className={`d-flex flex-column justify-content-center align-items-center rounded-circle ${*/}
            {/*                        index <= currentStep ? "bg-primary text-white" : "bg-light-subtle text-body-tertiary"*/}
            {/*                    }`}*/}
            {/*                    style={{width: "30px", height: "30px", zIndex: 1}}*/}
            {/*                >*/}
            {/*                    {index < currentStep ? <i className="bi bi-check mt-4 " style={{transform: 'scale(1.5)'}}/> :*/}
            {/*                        // <i className="bi bi-circle mt-4" style={{transform: 'scale(1.5)'}}/>*/}
            {/*                        <div className="mt-4">{index + 1}</div>*/}
            {/*                    }*/}

            {/*                    <div className={`${index <= currentStep ? "fw-semibold text-primary" : "text-body-tertiary"}`}><small>{step}</small></div>*/}
            {/*                </div>*/}

            {/*            </div>*/}
            {/*        ))}*/}
            {/*    </div>*/}
            {/*</div>*/}
        </>
    )
}
